import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import type {ImageLabelTileProps} from './image-label-tile.types';
import styles from './image-label-tile.module.scss';

export function ImageLabelTile({imageUrl, label, onClick, isSelected = false}: ImageLabelTileProps): ReactElement {
  return (
    <ClickableDiv className={styles.tile} onClick={onClick}>
      <div className={`${styles.imageContainer} ${isSelected ? styles.selected : ''}`}>
        <img className={styles.image} src={imageUrl} alt={label} />
      </div>
      <Text val={label} size={TextSize.SM} className="ct-neutral-primary" />
    </ClickableDiv>
  );
}
